import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { analyticsTrack } from '../../../analyticsUtils';
import { putRequest } from '../../../requestUtils';
import '../ProjectDetails.scss';
import ProTip from '../ProTip';

const TEXT_SUGGESTION = "We are a [add stage(s) of development here] - stage [add industry here] company focusing on [add company's primary technologies and/or therapeutic units of focus here]. We are looking for a [add role name here] consultant with proven expertise in [add primary therapeutic areas, product technologies, diseases, and/or other skill here] to accomplish [add key deliverables or milestones here]. Our ideal candidate will have [add required expertise and/or years of experience here]. [Add nice to have attributes or experience here] is preferred.";

const formStep = 'scope';

class ProjectScope extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
      errors: null,
      projectScope: props.projectScope,
    };

    this.handleShowModal = this.handleShowModal.bind(this);
    this.handleHideModal = this.handleHideModal.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleTextSuggestions = this.handleTextSuggestions.bind(this);
    this.setScope = this.setScope.bind(this);
  }

  componentDidMount() {
    const { projectResourceId, getProjectDetails } = this.props;

    if (!projectResourceId) return;

    getProjectDetails(formStep).then((response) => {
      this.setState({ projectScope: response.data.description });
    });
  }

  setScope(e) {
    this.setState({ projectScope: e.target.value });
  }

  handleShowModal() {
    this.setState({ showModal: true });
  }

  handleHideModal() {
    this.setState({ showModal: false });
  }

  handleBack() {
    if (this.props.formType === 'page') {
      this.props.back();
    } else {
      this.handleHideModal();
    }
  }

  handleSubmit() {
    const { csrfToken, projectResourceId, afterSubmit } = this.props;
    const { projectScope } = this.state;

    putRequest(
      `/projects/${projectResourceId}`,
      { project: { description: projectScope } },
      csrfToken,
    ).then(() => {
      afterSubmit();
    }).catch((error) => {
      this.setState({ errors: error.name });
    });
  }

  handleTextSuggestions() {
    const { projectScope } = this.state;
    analyticsTrack(
      'Inserted text suggestion (project scope)',
      { location: 'Project creation' },
    );
    let prevText = '';
    if (projectScope) {
      prevText = projectScope;
    }
    const textSuggestion = prevText + TEXT_SUGGESTION;
    this.setState({ projectScope: textSuggestion });
  }

  renderModal() {
    return (
      <Modal
        show={this.state.showModal}
        onHide={this.handleHideModal}
        dialogClassName="project-scope-modal"
      >
        <Modal.Header closeButton />
        <Modal.Body className="project-scope-modal-body">
          {this.renderContent()}
        </Modal.Body>
      </Modal>
    );
  }

  renderButtons() {
    const { backButtonText, submitButtonText } = this.props;
    const disabledState = (
      this.state.projectScope && this.state.projectScope.length > 3 ? '' : 'disabled'
    );

    return (
      <div className="buttons-container g-row mt-4">
        <div className="g-column g-flex-6" />
        <div className="g-column g-flex-3">
          <button className="btn btn-secondary button-back" onClick={this.handleBack}>
            {backButtonText}
          </button>
        </div>
        <div className="g-column g-flex-3">
          <button
            className={`btn btn-primary button-submit ${disabledState}`}
            onClick={this.handleSubmit}
            disabled={disabledState}
          >
            {submitButtonText}
          </button>
        </div>
      </div>
    );
  }

  renderErrors() {
    const { errors } = this.state;

    return (errors
      && (
      <div id="error_explanation">
        <h3>Errors prohibited this project from being saved:</h3>
        <ul>
          {errors.map((e) => (
            <li>{e}</li>
          ))}
        </ul>
      </div>
      )
    );
  }

  renderContent() {
    return (
      <div className="style-guide project-scope-container">
        <div className="g-row">
          <div className="g-column g-flex-1" />
          <div className="g-column g-flex-6 scope-entry-container">
            {this.renderErrors()}
            <h2>Describe your project</h2>
            <br />
            <div className="body-text-2 mb-2">
              Need help completing this section?&nbsp;
              <a onClick={this.handleTextSuggestions} tabIndex={0} role="button">
                Add Text Suggestions
              </a>
            </div>
            <br />
            <textarea
              name="projectScope"
              className="scope-form form-control fs-hide null"
              required="required"
              value={this.state.projectScope || null}
              onChange={this.setScope}
            />
            {this.renderButtons()}
          </div>
          <div className="g-column g-flex-3 protip-container">
            <ProTip>
              Add information about your company, the team, project scope,
              and candidate expectations.
            </ProTip>
          </div>
        </div>
      </div>
    );
  }

  renderModalLink() {
    return (
      <i
        role="button"
        tabIndex={0}
        className="fa fa-edit modal-link"
        onClick={this.handleShowModal}
      >
        {(this.props.formType === 'modal-link') ? 'Edit' : ''}
      </i>
    );
  }

  render() {
    if (this.props.formType === 'page') {
      return this.renderContent();
    }
    return (
      <div>
        { this.renderModalLink() }
        { this.renderModal() }
      </div>
    );
  }
}

ProjectScope.propTypes = {
  formType: PropTypes.string, // one of 'page', 'modal-link', 'modal-icon'
  projectResourceId: PropTypes.string,
  csrfToken: PropTypes.string.isRequired,
  back: PropTypes.func,
  afterSubmit: PropTypes.func,
  getProjectDetails: PropTypes.func.isRequired,
  projectScope: PropTypes.string,
  backButtonText: PropTypes.string,
  submitButtonText: PropTypes.string,
};

ProjectScope.defaultProps = {
  formType: 'page',
  projectResourceId: null,
  projectScope: '',
  back: () => {},
  afterSubmit: () => {},
  backButtonText: 'Back',
  submitButtonText: 'Next',
};

export default ProjectScope;
